"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCardType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _api = require("@whitbread-eos/api");
var _server = require("@whitbread-eos/utils/server");
var React = _interopRequireWildcard(require("react"));
var _CardIcon = require("../../CardIcon");
var _FormRadioGroup = require("../FormRadioGroup");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["cardDetails", "labelsLocation", "testId", "icons", "errors", "selectedValue"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardIconWrapper = _ref => {
  var {
    type,
    icons
  } = _ref;
  return (0, _jsxRuntime.jsx)("div", {
    className: cardIconContainer,
    children: (0, _jsxRuntime.jsx)(_CardIcon.CardIcon, {
      type: type,
      icons: icons,
      className: cardIcon
    })
  });
};
var FormCardType = exports.FormCardType = React.forwardRef((_ref2, ref) => {
  var _cardDetails$cardNumb, _cardDetails$cardType;
  var {
      cardDetails,
      labelsLocation,
      testId,
      icons,
      errors,
      selectedValue
    } = _ref2,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var isCardsLabels = labelsLocation === 'cards';
  var {
    t
  } = (0, _server.useTranslation)(['profile', 'cards']);
  var hasSavedCard = !!(cardDetails !== null && cardDetails !== void 0 && cardDetails.cardNumber);
  var keepCardOption = {
    value: (0, _server.getSavedCardType)(cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.cardType),
    label: (0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col",
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "flex",
        children: [(0, _jsxRuntime.jsx)("span", {
          children: "".concat(t('Keep the existing saved card:'), " (").concat(cardDetails === null || cardDetails === void 0 || (_cardDetails$cardNumb = cardDetails.cardNumber) === null || _cardDetails$cardNumb === void 0 ? void 0 : _cardDetails$cardNumb.slice(-8), ")")
        }), (0, _jsxRuntime.jsx)("div", {
          className: iconsContainerStyle,
          children: (0, _jsxRuntime.jsx)(CardIconWrapper, {
            type: (_cardDetails$cardType = cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.cardType) !== null && _cardDetails$cardType !== void 0 ? _cardDetails$cardType : '',
            icons: icons
          }, cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.cardType)
        })]
      }), (0, _jsxRuntime.jsxs)("div", {
        className: "flex",
        children: [(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col",
          children: [(0, _jsxRuntime.jsx)("span", {
            className: "font-normal text-sm text-darkGrey2",
            children: cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.nameOnCard
          }), (0, _jsxRuntime.jsx)("span", {
            className: "font-normal text-sm text-darkGrey2",
            children: "".concat(t('Expires'), " ").concat(cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.expiryDate)
          })]
        }), (0, _jsxRuntime.jsx)("div", {
          className: "text-[13px] ml-auto mt-auto text-secondaryColor border border-secondaryColor rounded-full font-bold px-2",
          children: t('Centrally stored')
        })]
      })]
    })
  };
  var paymentTypeItems = [{
    value: _api.PAYMENT_TYPES.NEW_CARD,
    label: (0, _jsxRuntime.jsxs)("div", {
      className: "flex",
      children: [(0, _jsxRuntime.jsx)("span", {
        children: isCardsLabels ? t('cards.centrallyStoredCard.card.type.newCredit.label') : t('profile.payment.paymentTypeNewDebitCreditCard')
      }), (0, _jsxRuntime.jsx)("div", {
        className: iconsContainerStyle,
        children: ['VI', 'MC', 'AX', 'DN'].map(type => (0, _jsxRuntime.jsx)(CardIconWrapper, {
          type: type,
          icons: icons
        }, type))
      })]
    })
  }, {
    value: _api.PAYMENT_TYPES.NEW_PIBA,
    label: (0, _jsxRuntime.jsxs)("div", {
      className: "flex",
      children: [(0, _jsxRuntime.jsx)("span", {
        children: isCardsLabels ? t('cards.centrallyStoredCard.card.type.newInnBusiness.label') : t('profile.payment.paymentTypeNewInnBusinessPayCard')
      }), (0, _jsxRuntime.jsx)("div", {
        className: iconsContainerStyle,
        children: (0, _jsxRuntime.jsx)(CardIconWrapper, {
          type: "PI",
          icons: icons
        }, "PI")
      })]
    })
  }];
  return (0, _jsxRuntime.jsx)(_FormRadioGroup.FormRadioGroup, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    variant: "col-styled",
    items: hasSavedCard ? [keepCardOption, ...paymentTypeItems] : paymentTypeItems,
    errors: errors,
    errorIcon: icons['icon.notification.error'],
    selectedValue: selectedValue,
    "data-testid": testId
  }));
});
FormCardType.displayName = 'FormCardType';
var cardIconContainer = 'w-[40px] h-[24px] rounded-[2px] flex items-center justify-center';
var cardIcon = 'w-full h-full object-contain';
var iconsContainerStyle = 'flex gap-1 ml-auto';